import Img1 from "./img/soal1.jpg"
import Img2 from "./img/soal2.jpg"
import Img3 from "./img/soal3.jpg"
import Img4 from "./img/soal4.jpg"
import Img5 from "./img/soal5.jpg"
import Img6 from "./img/soal6.jpg"
import Img7 from "./img/soal7.jpg"
import Img8 from "./img/soal8.jpg"
import Img9 from "./img/soal9.jpg"
import Img10 from "./img/soal10.png"
import Img11 from "./img/soal11.jpg"
import Img12 from "./img/soal12.jpg"
import Img13 from "./img/soal13.jpg"
import Img14 from "./img/soal14.png"
import Img15 from "./img/soal15.jpg"
import Img16 from "./img/soal16.jpg"
import Img17 from "./img/soal17.jpg"
import Img18 from "./img/soal18.png"
import Img19 from "./img/soal19.jpg"
import Img20 from "./img/soal20.png"

export const quiz = [
    {
        id : 1,
        soalgambar : Img1,
        pertanyaan : "1) Daerah yang tidak diarsir pada gamabr berikut merupakan himpunan penyelesaian dari sistem pertidaksamaan ....",
        options : [
            { 
                title : "x ≥ 0; 6x + y ≤ 12 ; 5x + 4y ≥ 20",
                op :"a",
                correct : true,
            },
            { 
                title : "x ≥ 0; 6x + y ≥ 12 ; 5x + 4y ≤ 20",
                op :"b",
                correct : false,
            },
            { 
                title : "x ≥ 0; 6x + y ≤ 12 ; 4x + 5y ≥ 20",
                op :"c",
                correct : false,
            },
            { 
                title : "x ≥ 0; x + 6y ≤ 12 ; 4x + 5y ≥ 20",
                op :"d",
                correct : false,
            },
            { 
                title : "x ≥ 0; 6x + y ≤ 12 ; 5x + 4y ≥ 20",
                op :"e",
                correct : false,
            },
        ],                
    },
    {
        id : 2,
        soalgambar : Img2,
        pertanyaan : "2) Daerah yang tidak mengenai arsiran pada grafik berikut adalah penyelesaian suatu masalah program linear, Sistem pertidaksamaan yang memenuhi adalah ....",
        options : [
            { 
                title : "0 ≤ x ≤ 4 ; x + y ≤ 6; y ≥ ",
                op :"a",
                correct : false,
            },
            { 
                title : "0 ≤ x ≤ 4 ; x + y ≤ 6; y ≥ 4",
                op :"b",
                correct : false,
            },
            { 
                title : "0 ≤ y ≤ 4 ; x + y ≥ 0; x ≥ 0",
                op :"c",
                correct : false,
            },
            { 
                title : "0 ≤ y ≤ 4 ; x + y ≤ 6; x ≥ 0",
                op :"d",
                correct : true,
            },
            { 
                title : "0 ≤ y ≤ 4 ; x + y ≤ 6; x ≤ 0",
                op :"e",
                correct : false,
            },
        ],  
    },
    {
        id : 3,
        soalgambar: Img3,
        pertanyaan : "3) Sistem pertidaksamaan yang memenuhi daerah yang tidak diarsir pada gambar berikut adalah  ....",
        options : [
            { 
                title : "2x - y ≥ -2 ; 3x + 4y ≤ 24; x ≥ 0 ; y ≥ 0 ;",
                op :"a",
                correct : true,
            },
            { 
                title : "2x - y ≤ -2 ; 3x + 4y ≤ 24; x ≥ 0 ; y ≥ 0 ;",
                op :"b",
                correct : false,
            },
            { 
                title : "2x - y ≥ -2 ; 3x + 4y ≥ 24; x ≥ 0 ; y ≥ 0 ;",
                op :"c",
                correct : false,
            },
            { 
                title : "x - 2y ≥ -2 ; 4x + 3y ≤ 24; x ≥ 0 ; y ≥ 0 ;",
                op :"d",
                correct : false,
            },
            { 
                title : "x - 2y ≤ -2 ; 4x + 4y ≤ 24; x ≥ 0 ; y ≥ 0 ;",
                op :"e",
                correct : false,
            },
        ],  
    },
    {
        id : 4,
        soalgambar: Img4,
        pertanyaan : "4) Seorang wiraswasta membuat dua macam ember yang setiap harinya menghasilkan tidak lebih dari 18 buah. Harga bahan untuk jenis pertama Rp500,00 dan untuk ember jenis kedua Rp1.000,00. Ia tidak akan berbelanja lebih dari Rp13.000,00 setiap harinya. Jika jenis ember pertama dibuat sebanyak x buah dan jenis kedua sebanyak y buah, maka sistem pertidaksamaanya adalah ....",
        options : [
            { 
                title : "x + y ≤ 18; x + 2y ≤ 26; x ≥ 0 ; y ≥ 0;",
                op :"a",
                correct : true,
            },
            { 
                title : "x + y ≤ 18; x + 2y ≤ 26; x ≤ 0 ; y ≤ 0;",
                op :"b",
                correct : false,
            },
            { 
                title : "x + y ≥ 18; 2x + y ≤ 26; x ≥ 0;",
                op :"c",
                correct : false,
            },
            { 
                title : "2x + y ≤ 26; x + 2y ≤ 26; y ≥ 0;",
                op :"d",
                correct : false,
            },
            { 
                title : "x + y ≤ 26; x ≥ 0 ; y ≥ 0;",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id : 5,
        soalgambar: Img5,
        pertanyaan : "5) Harga 1 kg pupuk jenis A Rp4.000,00 dan pupuk jenis B Rp2.000,00. Jika petani hanya mempunyai modal Rp800.000,00 dan gudang hanya mampu menampung 500kg pupuk (missal pupuk A = x dan pupuk B = y), maka model matematika dari permasalahan tersebut adalah ....",
        options : [
            { 
                title : "x + y ≥ 500 ; 2x + y ≥ 400 ; x ≥ 0; y ≥ 0 ;",
                op :"a",
                correct : false,
            },
            { 
                title : "x + y ≤ 500 ; 2x + y ≤ 400 ; x ≥ 0; y ≥ 0 ; ",
                op :"b",
                correct : true,
            },
            { 
                title : "x + y ≤ 500 ; 2x + y ≤ 400 ; x ≤ 0; y ≤ 0 ;",
                op :"c",
                correct : false,
            },
            { 
                title : "x + y ≥ 500 ; 2x + y ≥ 400 ; x ≤ 0; y ≤ 0 ;",
                op :"d",
                correct : false,
            },
            { 
                title : "x + y ≤ 500 ; 2x + y ≥ 400 ; x ≥ 0; y ≥ 0 ;",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id: 6,
        soalgambar: Img6,
        pertanyaan : "6) Suatu pesawat terbang mempunyai tempat duduk yang memuat tidak lebih dari 48 penumpang. Setiap penumpang kelas utama boleh membawa bagasi 60 kg sedangkan untuk kelas ekonomi 20 kg. Pesawat itu hanya dapat membawa bagasi 1.440 kg. Jika x dan y berturut-turut menyatakan banyak penumpang kelas utama dan ekonomi, maka model matematika dan persoalan diatas adalah ....",
        options : [
            { 
                title : "x + y ≤ 48; 3x + y ≥ 72; x ≥ 0 ; y ≥ 0 ;",
                op :"a",
                correct : false,
            },
            { 
                title : "x + y ≤ 48; 3x + y ≤ 72; x ≥ 0 ; y ≥ 0 ;",
                op :"b",
                correct : true,
            },
            { 
                title : "x + y ≤ 48; x + 3y ≥ 72; x ≥ 0 ; y ≥ 0 ;",
                op :"c",
                correct : false,
            },
            { 
                title : "x + y ≥ 48; x + 3y ≥ 72; x ≥ 0 ; y ≥ 0 ;",
                op :"d",
                correct : false,
            },
            { 
                title : "x + y ≥ 48; x + 3y ≥ 72; x ≤ 0 ; y ≤ 0 ;",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id : 7,
        soalgambar: Img7,
        pertanyaan : "7) Untuk membuat barang A diperlukan waktu 6 jam kerja mesin I dan 4 jam kerja mesin II,s edangkan untuk barang B diperlukan waktu 4 jam kerja mesin I dan 8 jam kerja mesin II. Setiap hari kedua mesin tersebut bekerja tidak lebih dari 18 jam. Jika setiap hari dapat dihasilkan x barang A dan y barang B, maka model matematikanya adalah sistem pertidaksamaan ....",
        options : [
            { 
                title : "6x + 4y ≤ 18; 2x + 8y ≤ 18, x ≥ 0 dan y ≥ 0",
                op :"a",
                correct : false,
            },
            { 
                title : "3x + 2y ≤ 9; 2x + 4y ≤ 9, x ≥ 0 dan y ≥ 0",
                op :"b",
                correct : true,
            },
            { 
                title : "2x + 3y ≤ 9; 4x + 2y ≤ 18, x ≥ 0 dan y ≥ 0",
                op :"c",
                correct : false,
            },
            { 
                title : "3x + 4y ≤ 9; 2x + 2y ≤ 9, x ≥ 0 dan y ≥ 0",
                op :"d",
                correct : false,
            },
            { 
                title : "2x + 3y ≤ 9; 2x + 4y ≤ 9, x ≥ 0 dan y ≥ 0",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id : 8,
        soalgambar: Img8,
        pertanyaan : "Sebuah pesawat terbang mempunyai 60 tempat duduk. Setiap penumpang kelas utama boleh membawa barang hingga 50kg, sedangkan untuk setiap penumpang kelas ekonomi boleh membawa barang 20kg. Bagasi pesawat itu hanya mampu menampung barang seberat 1.150kg. Jika harga tiket kelas utama Rp500.000,00 dan untuk harga tiket kelas ekonomi Rp300.000,00, pendapatan maksimum untuk sekali penerbangan adalah ....",
        options : [
            { 
                title : "Rp15.000.000,00",
                op :"a",
                correct : false,
            },
            { 
                title : "Rp18.000.000,00",
                op :"b",
                correct : false,
            },
            { 
                title : "Rp20.000.000,00",
                op :"c",
                correct : true,
            },
            { 
                title : "Rp22.000.000,00",
                op :"d",
                correct : false,
            },
            { 
                title : "30.000.000,00",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id : 9,
        soalgambar: Img9,
        pertanyaan : "Amin seorang pedagang pakaian, dia menjual dua jenis pakaian yaitu kemeja dan celana panjang. Harga beli kemeja adalah Rp100.000,00 yang akan dijual dengan harga Rp120.000,00 per potong, sedangkan harga beli celana panjang adalah Rp150.000,00 yang dijual dengan harga Rp175.000,00 per potong. Modal yang dimiliki adalah Rp30.000.000,00 dan toko pakaian tersebut hanya dapat memuat 250 potong pakaian. Keuntungan maksimum yang didapat Amin jika ia menjual  ...",
        options : [
            { 
                title : "150 kemeja dan 100 celana panjang",
                op :"a",
                correct : true,
            },
            { 
                title : "100 kemeja dan 150 celana panjang",
                op :"b",
                correct : false,
            },
            { 
                title :"250 kemeja dan 200 celana panjang",
                op :"c",
                correct : false,
            },
            { 
                title : "250 kemeja saja",
                op :"d",
                correct : false,
            },
            { 
                title : "250 celana panjang saja",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id : 10,
        soalgambar: Img10,
        pertanyaan :"Rika merupakan seorang pedagang makanan yang menggunakan gerobak menjual pisang keju dan sukun. Harga pembelian untuk pisang keju Rp1.000,00/biji dan sukun Rp400,00/biji. Jika keuntungan dari pisang keju Rp500,00/biji dan sukun Rp300,00/biji, keuntungan maskimum yang dapat diperoleh Rika adalah ....",
        options : [
            { 
                title : "Rp150.000,00",
                op :"a",
                correct : true,
            },
            { 
                title : "Rp165.000,00",
                op :"b",
                correct : false,
            },
            { 
                title : "Rp175.000,00",
                op :"c",
                correct : false,
            },
            { 
                title : "Rp187.000,00",
                op :"d",
                correct : false,
            },
            { 
                title : "Rp200.000,00",
                op :"e",
                correct : false,
            }
        ],  
    }, 
    {
        id : 11,
        soalgambar: Img11,
        pertanyaan : "11) Daerah yang diarsir pada gambar brikut ini adalah himpunan penyelesaian suatu sistem pertidaksamaan linier. Nilai maksimum unutk 5x + 4y dari daerah penyelesaian tersebut adalah  ....",
        options : [
            { 
                title : "9",
                op :"a",
                correct : false,
            },
            { 
                title : "7",
                op :"b",
                correct : false,
            },
            { 
                title : "16",
                op :"c",
                correct : false,
            },
            { 
                title : "20",
                op :"d",
                correct : false,
            },
            { 
                title : "22",
                op :"e",
                correct : true,
            }
        ],  
    },
    {
        id : 12,
        soalgambar: Img12,
        pertanyaan : "12) Daerah yang tidak diarsir pada grafik dibawah ini merupakan himpunan penyelesaian suatu sistem pertidaksamaan. Nilai maksimum 5x + 4y adalah ....",
        options : [
            { 
                title : "16",
                op :"a",
                correct : false,
            },
            { 
                title : "20",
                op :"b",
                correct : false,
            },
            { 
                title : "23",
                op :"c",
                correct : true,
            },
            { 
                title : "24",
                op :"d",
                correct : false,
            },
            { 
                title : "27",
                op :"e",
                correct : false,
            }
        ],  
    }, 
    {
        id : 13,
        soalgambar: Img13,
        pertanyaan : "13) Pesawat penumpang mempunyai tempat duduk 48 kursi. Setiap penumpang kelas utama boleh membawa bagasi 60 kg sedang kelas ekonomi 20 kg. Pesawat hanya dapat membawa bagasi 1.440kg. Harga tiket kelas utama Rp150.000,00 dan kelas ekonomi Rp100.000,00. Supaya pendapatan dari penjualan tiket pada saat pesawat penuh mencapai maksimum, jumlah tempat duduk kelas utama haruslah ....",
        options : [
            { 
                title : "12",
                op :"a",
                correct : true,
            },
            { 
                title : "20",
                op :"b",
                correct : false,
            },
            { 
                title : "24",
                op :"c",
                correct : false,
            },
            { 
                title : "26",
                op :"d",
                correct : false,
            },
            { 
                title : "36",
                op :"e",
                correct : false,
            }
        ],  
    }, 
    {
        id : 14,
        soalgambar: Img14,
        pertanyaan : "14) Nilai maksimum fungsi objektif 4x + 2y pada himpunan penyelesaian sistem petidaksamaan x + y ≥ 4 ; x + y ≤ 9; -2x +3y ≤ 12 ; 3x - 2y ≤ 12 adalah ....",
        options : [
            { 
                title : "16",
                op :"a",
                correct : false,
            },
            { 
                title : "24",
                op :"b",
                correct : false,
            },
            { 
                title : "30",
                op :"c",
                correct : true,
            },
            { 
                title : "36",
                op :"d",
                correct : false,
            },
            { 
                title : "48",
                op :"e",
                correct : false,
            }
        ],  
    }, 
    {
        id : 15,
        soalgambar: Img15,
        pertanyaan : "15) Himpunan penyelesaian dari sistem pertidaksamaan linear x + y ≤ 6. 2x + y ≤ 8, x ≥ 0, y ≥ 0, mempunyai nilai maksimum pada fungsi objektif f(x,y) = 3x + 5y sebesar ....",
        options : [
            { 
                title : "20",
                op :"a",
                correct : false,
            },
            { 
                title : "23",
                op :"b",
                correct : false,
            },
            { 
                title : "26",
                op :"c",
                correct : false,
            },
            { 
                title : "30",
                op :"d",
                correct : true,
            },
            { 
                title : "32",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id : 16,
        soalgambar: Img16,
        pertanyaan : "16) Daerah yang diarsir pada gambar merupakan himpunan penyelesaian sistem pertidaksamaan. Nilai minimum bentuk objketif 3x + 4y adalah ....",
        options : [
            { 
                title : "0",
                op :"a",
                correct : true,
            },
            { 
                title : "3",
                op :"b",
                correct : false,
            },
            { 
                title : "4",
                op :"c",
                correct : false,
            },
            { 
                title : "5",
                op :"d",
                correct : false,
            },
            { 
                title : "7",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id : 17,
        soalgambar: Img17,
        pertanyaan : "17) Nilai minimum fungsi objektif f (x,y) = 8x + y dengan kendala 3x + 2y ≥ 24 ; x ≥ 2 dan y ≥ 3 adalah  ....",
        options : [
            { 
                title : "32",
                op :"a",
                correct : false,
            },
            { 
                title : "25",
                op :"b",
                correct : true,
            },
            { 
                title : "22",
                op :"c",
                correct : false,
            },
            { 
                title : "20",
                op :"d",
                correct : false,
            },
            { 
                title : "18",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id : 18,
        soalgambar: Img18,
        pertanyaan : "18) Nilai minimum fungsi objektif x + 3y yang memenuhi pertidaksamaan 3x + 2y ≥ 12 ; x + 2y ≥ 8 ;  x + y ≤ 8 ;  x ≥ 0 adalah ",
        options : [
            { 
                title : "8",
                op :"a",
                correct : true,
            },
            { 
                title : "9",
                op :"b",
                correct : false,
            },
            { 
                title : "11",
                op :"c",
                correct : false,
            },
            { 
                title : "18",
                op :"d",
                correct : false,
            },
            { 
                title : "24",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id : 19,
        soalgambar: Img19,
        pertanyaan : "19) Seorang anak balita dianjurkan dokter untuk mengonsumsi kalsium dan zat besi sedikitnya 60 g dan 30 g. Sebuah kapsul mengandung 5 kg kalsium dan 2g zat besi,sedangkan sebuah tablet mengandung 2g kalsium dan 2g zat besi. Jika harga sebuah kapsul Rp1.000,00 dan harga sebuah tablet Rp800,00, maka biaya minimum yang harus dikeluarkan  untuk memenuhi kebutuhan anak balita tersebut adalah ....",
        options : [
            { 
                title : "Rp12.000,00",
                op :"a",
                correct : false,
            },
            { 
                title : "Rp14.000,00",
                op :"b",
                correct : true,
            },
            { 
                title : "Rp18.000,00",
                op :"c",
                correct : false,
            },
            { 
                title : "Rp24.000,00",
                op :"d",
                correct : false,
            },
            { 
                title : "Rp36.000,00",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id : 20,
        soalgambar: Img20,
        pertanyaan : "20) Seorang anak diharuskan minum dua jenis tablet setiap hari. Tablet jenis I mengandung 5 unit vitamin A dan 3 unit vitamin B. Tablet jenis II mengandung 10 unit vitamin A dan 1 unit vitamin B. Dalam 1 hari anak tersebut memerlukan 25 unit vitamin A dan 5 unit vitamin B. Jika harga tablet II Rp8.000,00 per biji, pengeluaran minimum untk pembelian tablet per hari adalah ....",
        options : [
            { 
                title : "Rp12.000,00",
                op :"a",
                correct : false,
            },
            { 
                title : "Rp14.000,00",
                op :"b",
                correct : false,
            },
            { 
                title : "Rp16.000,00",
                op :"c",
                correct : false,
            },
            { 
                title : "Rp18.000,00",
                op :"d",
                correct : false,
            },
            { 
                title : "Rp20.000,00",
                op :"e",
                correct : true,
            }
        ],  
    },
];